import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SharedModule } from "./shared/shared.module";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule } from "@angular/common";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { AuthModule } from "./modules/auth/auth.module";
import { MainModule } from "./modules/main/main.module";
import { CoreModule } from "./core/core.module";
import { StoreModule } from "@ngrx/store";
import { reducers } from "./core/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { environment } from "../environments/environment";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule } from "@angular/forms";
import { PrimeNG, providePrimeNG } from "primeng/config";
import Aura from "@primeng/themes/aura";

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CommonModule,
    SharedModule.forRoot(),
    AuthModule,
    MainModule,
    CoreModule,
    FormsModule,
    NgbModule,
    StoreDevtoolsModule.instrument({
      maxAge: 10,
      logOnly: environment.production,
      connectInZone: true,
    }),
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: 'none' } } }),
  ],
})
export class AppModule {
  constructor(primeNG: PrimeNG) {
    // Keep dialogs above the app while allowing PrimeNG to order nested dialogs.
    primeNG.zIndex.modal = 110000;
  }
}
